import { optinStatusType } from './types';

const OPTIN_TEXTS: Record<optinStatusType, { paragraphs: string[]; radioButtonLabel: string }> = {
    accepted: {
        paragraphs: [
            'Je reconnais et accepte expressément que ces éléments puissent être intégrés,tout ou partie, à tout support édité et diffusé par l’ESAJ.',
            'J’en autorise la diffusion, par le biais des réseaux numériques (Internet, sociaux...,), de téléphonie mobile à des fins promotionnelles, d’illustration, de communication, trombinoscope, d’information pendant ma scolarité.',
            'Dans le cas de vidéos, j’autorise l’ESAJ à faire les coupures nécessaires au montage et à la diffusion. Il est entendu que l’ESAJ s’interdit expressément une exploitation des images susceptibles de porter atteinte à ma vie privée et une diffusion sur tout support à caractère pornographique, xénophobe, violent ou illicite.',
            'Je reconnais par ailleurs que je ne suis lié à aucun contrat exclusif sur l’utilisation de mon image ou de mon nom. La présente autorisation est consentie gracieusement et s’entend pour la durée de mes études et 5 ans au-delà.',
            'Elle peut être révoquée à tout moment, en adressant un courrier au service Administration de l’ESAJ.',
        ],
        radioButtonLabel:
            "autorise l'ESAJ à me photographier, me filmer et m’enregistrer dans le cadre de mes activités au cours de ma scolarité à l’ESAJ.",
    },
    refused: {
        paragraphs: [],
        radioButtonLabel:
            "n'autorise pas l’ESAJ à me photographier, me filmer et m’enregistrer dans le cadre de mes activités au cours de ma scolarité à l’ESAJ.",
    },
};

export { OPTIN_TEXTS };
